import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowLeft,
  BadgeCheck,
  Check,
  Lock,
  MessageCircle,
} from 'lucide-react';
import { Marca } from '../componentes/Marca';
import { CNPJ, NOME_FANTASIA } from './publico/constantes';
import css from './Auth.module.css';

/**
 * Moldura de login, cadastro, verificação e troca de senha.
 *
 * Duas colunas: o formulário à esquerda e, à direita, o painel da marca com o
 * que o serviço faz — só fato verificável, nada de depoimento ou contagem de
 * clientes. No celular vira uma coluna, com o formulário primeiro.
 */
export function MolduraAuth({ children }: { children: ReactNode }) {
  return (
    <div className={css.moldura}>
      <div className={css.colunaForm}>
        <header className={css.topo}>
          <Link to="/" aria-label="baixaxml — página inicial" className={css.marca}>
            <Marca tamanho={24} fonte={20} />
          </Link>
          <Link to="/" className={css.voltar}>
            <ArrowLeft aria-hidden="true" />
            Voltar ao site
          </Link>
        </header>

        <main className={css.formulario}>{children}</main>

        <footer className={css.rodape}>
          <span>
            {NOME_FANTASIA} · CNPJ {CNPJ}
          </span>
          <Link to="/privacidade">Política de Privacidade</Link>
        </footer>
      </div>

      <aside className={css.painel} aria-label="Sobre o baixaxml">
        <div className={css.painelConteudo}>
          <span className={css.painelSobretitulo}>
            Para escritórios contábeis e fiscais
          </span>
          <p className={css.painelTitulo}>
            Os XMLs dos seus clientes, num ZIP — sem caçar nota a nota.
          </p>
          <ul className={css.beneficios}>
            <li>
              <Check aria-hidden="true" />
              <span>
                <b>Pela chave de acesso ou direto do SPED.</b> De uma nota a um
                milhão por lote.
              </span>
            </li>
            <li>
              <Check aria-hidden="true" />
              <span>
                <b>Sem certificado digital.</b> Nem procuração, nem programa
                para instalar.
              </span>
            </li>
            <li>
              <Check aria-hidden="true" />
              <span>
                <b>Paga só o XML entregue.</b> Chave não encontrada volta para o
                saldo.
              </span>
            </li>
            <li>
              <Check aria-hidden="true" />
              <span>
                <b>Recarga por Pix.</b> Sem mensalidade e sem fidelidade.
              </span>
            </li>
          </ul>

          <div className={css.selos}>
            <span>
              <BadgeCheck aria-hidden="true" /> XML original, com a assinatura
              digital do emitente
            </span>
            <span>
              <Lock aria-hidden="true" /> Conexão cifrada e senha guardada só
              como hash
            </span>
            <span>
              <MessageCircle aria-hidden="true" /> Atendimento pelo chat de
              suporte
            </span>
          </div>
        </div>
      </aside>
    </div>
  );
}

/** Título e subtítulo do formulário — a mesma abertura em toda tela de acesso. */
export function CabecalhoAuth({
  titulo,
  children,
}: {
  titulo: string;
  children?: ReactNode;
}) {
  return (
    <div className={css.cabecalho}>
      <h1>{titulo}</h1>
      {children && <p>{children}</p>}
    </div>
  );
}
